import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getAllArticles } from '../components/articles';

const BlogPage = () => {
  const [articles, setArticles] = useState([]);

  useEffect(() => {
    // Get articles from shared data source
    setArticles(getAllArticles());
  }, []);

  return (
    <div className="blog-page">
      <div className="blog-header">
        <div className="blog-header-content">
          <h1>GimmeResume Blog</h1>
          <p>Expert insights on resume optimization, job market trends, and career advice</p>
        </div>
      </div>

      <div className="blog-container">
        <div className="articles-grid">
          {articles.map((article) => (
            <article key={article.id} className="article-card">
              <Link to={`/blog/${article.id}`} className="article-image">
                <div className="article-image">
                  <img src={article.image} alt={article.title} />
                </div>
              </Link>
              <div className="article-content">
                <div className="article-meta">
                  <span className="article-date">{new Date(article.date).toLocaleDateString()}</span>
                  <span className="article-read-time">{article.readTime}</span>
                </div>
                <h2 className="article-title">
                  <Link to={`/blog/${article.id}`}>{article.title}</Link>
                </h2>
                <p className="article-excerpt">{article.excerpt}</p>
                <div className="article-footer">
                  <span className="article-author">By {article.author}</span>
                  <Link to={`/blog/${article.id}`} className="read-more-link">
                    Read More →
                  </Link>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BlogPage;
